import { SVGProps } from 'react';
export const IconChatUILogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m9.605 23.25-.007-2.999c.618 0 1.14-.436 1.936-1.142.923-.812 2.07-1.826 3.768-1.879.834-.06 1.735-.135 2.637-.225.878-.09 1.742-.955 1.802-1.819.2-2.878.2-4.299-.008-7.192-.067-.88-.975-1.766-1.869-1.826a105.555 105.555 0 0 0-11.744 0C5.234 6.22 4.325 7.115 4.258 8c-.208 2.909-.208 4.367 0 7.29.067.88.976 1.766 1.87 1.819a87.72 87.72 0 0 0 3.47.135v3.006c-1.207-.03-2.45-.075-3.642-.142-2.39-.15-4.483-2.21-4.669-4.6-.216-3.074-.216-4.674 0-7.74.194-2.39 2.286-4.45 4.67-4.6a108.08 108.08 0 0 1 12.086 0c2.39.15 4.483 2.21 4.67 4.6.215 3.043.215 4.606.006 7.635-.178 2.345-2.144 4.359-4.49 4.592-.93.09-1.854.165-2.77.233-.663.022-1.177.45-1.966 1.142-.946.834-2.123 1.879-3.888 1.879Z'
    />
  </svg>
);
